import pattern from '../../../pattern.svg';

import { useState, useEffect } from 'react';

import { useStep } from '../../Base/StepContext';
import { useGlobal } from '../../../Core/GlobalState/Store';
import LoadingSpinner from '../../ReusableComponents/LoadingSpinner';
import MapService from '../../../Core/Services/MapService';

import { PlacementSelectBodyComponent } from './Body/PlacementSelectBody';
import PlacementSelectorHeader from './Headers/PlacementSelectorHeader';

export default function PlacementSelect() {
  const { handleNext } = useStep();

  const [roomList, setRoomList] = useState([]);
  const [siteMap, setSiteMapData] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(0);

  const {
    currentLocation: location,
    pluginUrl,
    loading,
    setLoading,
    sizeTypes,
    setSizeTypes,
    selectedSize,
    setSelectedSize,
  } = useGlobal();

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        setLoading(true);
        if (!location || !location.id) {
          setLoading(false);
          return;
        }

        const response = await MapService.fetchMapDataByLocationId(location.id);

        if (!response || !response.mapData) {
          if (isMounted) {
            setSiteMapData(null);
            setRoomList([]);
          }
          return;
        }

        try {
          const parsed = JSON.parse(response.mapData);
          if (isMounted) {
            setSiteMapData(parsed);
            setRoomList(MapService.generateAvailableRoomList(parsed));
          }
        } catch (e) {
          if (isMounted) {
            setSiteMapData(null);
            setLoading(false);
            setRoomList([]);
          }
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [location]);

  useEffect(() => {
    if (!siteMap) return;
    try {
      const newSizeTypes = MapService.addFromPriceAndAvailableAmountToSizeTypes(
        siteMap,
        sizeTypes
      );
      setSizeTypes(newSizeTypes);
    } catch (e) {}
  }, [siteMap]);

  return (
    <div
      className="w-full flex flex-col !border-solid !border-l !border-r border-gray-300 border-1"
      style={{
        backgroundImage: `url(${pluginUrl + pattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
      }}
    >
      <PlacementSelectorHeader />

      {loading && (
        <div className="flex justify-center items-center h-[400px]">
          <LoadingSpinner />
        </div>
      )}

      {!loading && siteMap && (
        <PlacementSelectBodyComponent
          roomList={roomList}
          selectedLevel={selectedLevel}
          setSelectedLevel={setSelectedLevel}
          selectedSize={selectedSize}
          setSelectedSize={setSelectedSize}
          showPlacementBody={true}
          setShowPlacementBody={() => {}}
          handleNext={handleNext}
          mapService={MapService}
          siteMap={siteMap}
        />
      )}
    </div>
  );
}
